<template>
  <div>
    <div>
      <span class="label">Співробітник</span>
      <employee-autocomplete
        v-model="staffUnitCredentials.employeeId"
        :default-item="staffUnitSource?.employee"
        :error-messages="getErrorMessages(v$.employeeId)">
      </employee-autocomplete>
    </div>
    <v-card border class="bg-grey-lighten-4 mb-3" elevation="0" rounded="lg">
      <v-card-text>
        <div
          class="text-uppercase text-caption font-weight-bold text-medium-emphasis mb-3">
          ШТАТНА ОДИНИЦЯ
        </div>

        <v-row dense>
          <v-col cols="12" md="6">
            <div class="text-caption text-medium-emphasis">Повна назва</div>
            <div class="text-body-2 mb-3">
              {{ staffUnit.name }}
            </div>

            <div class="text-caption text-medium-emphasis">Посада</div>
            <div class="text-body-2">
              {{ staffUnit.position?.name }}
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="text-caption text-medium-emphasis">Підрозділ</div>
            <div class="text-body-2 mb-3">
              {{ staffUnit.department?.name }}
            </div>

            <div class="text-caption text-medium-emphasis">
              Тип штатної одиниці
            </div>
            <div class="text-body-2">
              {{ staffUnit.staffUnitType?.name }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <b-select
      v-model="staffUnitCredentials.appointmentTypeId"
      :error-messages="getErrorMessages(v$.appointmentTypeId)"
      :items="$directory.get('orgAppointmentTypes')"
      :loading="$loading.isLoading('orgAppointmentTypes')"
      item-title="name"
      item-value="id"
      label="Тип призначення"
      placeholder="Оберіть зі списку"
      @blur="v$.appointmentTypeId.$touch()" />
    <b-input
      v-model="staffUnitCredentials.description"
      label="Опис"
      placeholder="Введіть опис" />
    <v-row>
      <v-col cols="12" md="6">
        <b-input-date
          v-model="staffUnitCredentials.dateFrom"
          :disabled-dates="disabledDates"
          :error-messages="getErrorMessages(v$.dateFrom)"
          label="Дата початку"
          @blur="v$.dateFrom.$touch()"></b-input-date>
      </v-col>
      <v-col cols="12" md="6">
        <b-input-date
          v-model="staffUnitCredentials.dateTo"
          :disabled-dates="disabledDates"
          label="Дата закінчення"></b-input-date>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { computed, reactive, ref } from 'vue'
import { axios, required, useVuelidate } from '@/plugins'
import { getDatesInRange, getErrorMessages } from '@/utils/helpers'
import {
  urlCreateStaffUnitAssignment,
  urlUpdateStaffUnitAssignment,
} from '@/utils/urls'
import { setSnackbar } from 'best-modules/plugins'
import { fillDirectory } from '@/directory/index.ts'
import { BInputDate } from 'best-modules/components'
import EmployeeAutocomplete from '@/components/inputs/employee-autocomplete/EmployeeAutocomplete.vue'

export default {
  name: 'StaffUnitAssignmentDialog',
  components: { BInputDate, EmployeeAutocomplete },
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  async setup(props) {
    await fillDirectory(['userList', 'orgAppointmentTypes'])

    const isUpdate = props.dialog.action === 'update'
    const staffUnitSource = props.dialog.dialogData?.itemData
    const staffUnit = props.dialog.dialogData?.staffUnit

    const staffUnitCredentials = reactive({
      staffUnitId: staffUnitSource?.staffUnitId || staffUnit?.id || null,
      employeeId: staffUnitSource?.employeeId || null,
      appointmentTypeId: staffUnitSource?.appointmentTypeId || null,
      description: staffUnitSource?.description || null,
      dateFrom: staffUnitSource?.dateFrom || null,
      dateTo: staffUnitSource?.dateTo || null,
    })

    const disabledDates = computed(() => {
      const employee = props.dialog.dialogData?.otherAssignments?.find(
        assignment => assignment.employeeId === staffUnitCredentials.employeeId
      )

      if (employee) {
        return getDatesInRange(employee.dateFrom, employee.dateTo)
      } else {
        return []
      }
    })

    const serverDateFromError = ref(null)

    const v$ = useVuelidate(
      {
        employeeId: { required },
        appointmentTypeId: { required },
        dateFrom: { required },
      },
      staffUnitCredentials
    )

    const submit = () => {
      serverDateFromError.value = null
      const url = isUpdate
        ? urlUpdateStaffUnitAssignment(staffUnitSource.id)
        : urlCreateStaffUnitAssignment()
      return axios({
        url,
        method: isUpdate ? 'put' : 'post',
        data: staffUnitCredentials,
      })
        .then(res => {
          setSnackbar({
            text: `Призначення ${isUpdate ? 'оновлено' : 'створено'}`,
          })
          return res.data
        })
        .catch(err => {
          const dateFromError = err?.response?.data?.errors?.dateFrom
          if (dateFromError) {
            serverDateFromError.value = Array.isArray(dateFromError)
              ? dateFromError[0]
              : dateFromError
          }
          return Promise.reject(err)
        })
    }

    return {
      staffUnitCredentials,
      v$,
      submit,
      staffUnit,
      serverDateFromError,
      disabledDates,
      staffUnitSource,
      validationScope: 'staffUnitAssignment',
    }
  },
}
</script>
